import React from 'react';
import PropTypes from 'prop-types';
import { BebopFeaturesCard } from './BebopFeaturesCard';

export const BebopFeatures = ({ title, subTitle, appStoreButton, content }) => {
  return (
    <div className="content-wrapper">
      <section className="bebop-features row start-xs center-sm scalable-content-section">
        <h2 className="bebop-features__title heading--title--large col-xs-12">
          {title}
        </h2>
        <p className="bebop-features__subTitle col-xs-12">{subTitle}</p>
        <div className="bebop-features__app-store-icon col-xs-4 col-sm-12">
          <img src={appStoreButton} />
        </div>

        {content.map((content, i) => (
          <BebopFeaturesCard content={content} key={i} />
        ))}
      </section>
    </div>
  );
};

BebopFeatures.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  appStoreButton: PropTypes.string,
  content: PropTypes.arrayOf(PropTypes.object),
};
